import React from 'react';
import ProductTopSection from '../../../../components/Sangjo-Ujieon/ProductTopSection';
import ProductSubHeading from '../../../../components/Sangjo-Ujieon/ProductSubHeading';
import FuneralTabPC from '../../../../components/Sangjo-Ujieon/FuneralTabPC';
import rectangle1 from '../../../../assets/img/product-info/rectangle1.png';
import rectangle2 from '../../../../assets/img/product-info/rectangle2.png';
import rectangle3 from '../../../../assets/img/product-info/rectangle3.png';

const FuneralInformationOtherPC = () => {

  return (
    <div className="announcement-list-page product-info-page">
      <ProductTopSection />

      {/* Main Content */}
      <main className="main-content">
        <ProductSubHeading heading="장례정보" />

        <FuneralTabPC />

        {/* Main Content */}
        <div className="funeral-information-other-main-content">
          <div className="funeral-information-other-page-content">
            <div className="funeral-information-other-container">

              <h2 className="funeral-information-other-section-title">기타</h2>

              {/* Priority Order of Chief Mourner */}
              <div className="funeral-information-other-section">
                <h3 className="funeral-information-other-subtitle">상주의 우선순위</h3>
                <ul className="funeral-information-other-list">
                  <li>자손이 없을 경우에는 가장 가까운 촌수의 친족 중에서 나이 많은 자가 된다.</li>
                  <li>아내의 상에는 남편이 된다.</li>
                </ul>
              </div>

              {/* Priority Order of Main Mourner */}
              <div className="funeral-information-other-section">
                <h3 className="funeral-information-other-subtitle">주부의 우선순위</h3>
                <ul className="funeral-information-other-list">
                  <li>상사에서 인덕을 주관하는 사람을 주부(主婦)라 하는데, 주부는 죽은 사람의 아내가 된다.</li>
                  <li>아내가 없으면 상주의 아내가 된다.</li>
                </ul>

                {/* Flow Diagram */}
                <div className="funeral-information-other-flow-diagram">
                  <div className="funeral-information-other-flow-step">
                    <div className="funeral-information-other-flow-circle">
                      <span>1순위</span>
                      <div className="funeral-information-other-flow-text">죽은 사람의<br /> 장자(長子)</div>
                    </div>
                  </div>
                  <img src="/images/ProductInfo/914028441c5b9a3d9ff37ef903d305d4bbd2b1de.png" alt="arrow" className="funeral-information-other-arrow-icon" />
                  <div className="funeral-information-other-flow-step">
                    <div className="funeral-information-other-flow-circle">
                      <span>2순위</span>
                      <div className="funeral-information-other-flow-text">장자가 없으면<br /> 장손</div>
                    </div>
                  </div>
                  <img src="/images/ProductInfo/914028441c5b9a3d9ff37ef903d305d4bbd2b1de.png" alt="arrow" className="funeral-information-other-arrow-icon" />
                  <div className="funeral-information-other-flow-step">
                    <div className="funeral-information-other-flow-circle">
                      <span>3순위</span>
                      <div className="funeral-information-other-flow-text">장손도 없으면<br /> 장증손, 장고손</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Chief Mourner */}
              <div className="funeral-information-other-section mb-20">
                <h3 className="funeral-information-other-subtitle">주상</h3>

                <ul className="funeral-information-other-list">
                  <li>검정예복에는 완장을 착용하는데 상주의 외쪽 팔에 차는 것이며 근친 간을 구분하기 위하여 상주 표시로 검은 좋을 넣었으나 요즘 일부 업소에서는 너무 많은 줄을 사용함으로써 모든 사람들에게 혼란을 주고 있다.</li>
                </ul>

                <div className="funeral-information-other-mourning-types">
                  <div className="funeral-information-other-mourning-type">
                    <img src={rectangle1} alt="rectangle1" />
                    <div className="funeral-information-other-type-content">
                      <span className="funeral-information-other-label">두줄</span> - 상주 (상제 중 맏이가 되는 자)
                    </div>
                  </div>
                  <div className="funeral-information-other-mourning-type">
                    <img src={rectangle2} alt="rectangle2" />
                    <div className="funeral-information-other-type-content">
                      <span className="funeral-information-other-label">한줄</span> - 상제(상주 이외의 형제자매)
                    </div>
                  </div>
                  <div className="funeral-information-other-mourning-type">
                    <img src={rectangle3} alt="rectangle3" />
                    <div className="funeral-information-other-type-content">
                      <span className="funeral-information-other-label">무줄</span> - 상주 이외 복인들, 8촌 이내
                    </div>
                  </div>
                </div>
              </div>

              {/* Women's Mourning Clothes */}
              <div className="funeral-information-other-section">
                <ul className="funeral-information-other-list">
                  <li><span>여상복 &nbsp;</span> - 우리의 상복은 하얀 광목으로 입었으나 현재는 검정 또는 흰색 치마저고리를 입기도 한다.</li>
                  <li>자녀상 중에서 자녀의 후사가 없을 경우 고인의 부모 또는 형제가 주상으로서 역할을 하기도 한다.</li>
                </ul>
              </div>

            </div>
          </div>
        </div>
      </main>

    </div>
  );
};

export default FuneralInformationOtherPC; 